import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const columns = [
    {
      title: 'Kategorien',
      links: [
        { label: 'Inspiration', to: '/inspiration' },
        { label: 'Alle Kategorien', to: '/kategorien' },
      ],
    },
    {
      title: 'Entdecken',
      links: [
        { label: 'Feiernde', to: '/for-customers' },
        { label: 'Eventpros', to: '/for-providers' },
        { label: 'Preise', to: '/pricing' },
      ],
    },
    {
      title: 'Support',
      links: [
        { label: 'Impressum', to: '/impressum' },
        { label: 'Datenschutz', to: '/datenschutz' },
        { label: 'AGB', to: '/agb' },
        { label: 'Widerruf & Kündigung', to: '/widerruf' },
      ],
    },
  ];

  return (
    <footer className="relative overflow-hidden bg-peach text-navy rounded-t-[40px] sm:rounded-t-[50px] px-6 sm:px-12 lg:px-16 pt-16 pb-10">
      {/* Decorative swoosh */}
      <img
        src="/images/footer-swoosh.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none select-none absolute inset-0 w-full h-full object-cover opacity-25"
      />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Top: tagline + link columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-16">
          {/* Tagline */}
          <div className="lg:col-span-2">
            <p className="text-2xl sm:text-3xl lg:text-[40px] font-medium leading-snug tracking-tight max-w-md">
              Wir verbinden Feiernde und Eventpros aus der Region &ndash; unkompliziert, ehrlich und ohne Umwege.
            </p>
          </div>

          {/* Link columns */}
          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-medium text-lg mb-5">{col.title}</h4>
              <ul className="space-y-4">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => navigate(link.to)}
                      className="text-lg text-navy/90 hover:text-navy hover:opacity-70 text-left transition-opacity"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom: logo + copyright */}
        <div>
          <img
            src="/images/ec-logo-navy.svg"
            alt="event connect"
            onClick={() => navigate('/')}
            className="h-7 w-auto cursor-pointer hover:opacity-80 transition-opacity"
          />
          <p className="text-center text-navy/70 text-sm mt-10">&copy; 2026 EventConnect</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
